import React, { useState, useRef, useEffect } from "react";
import { IAnalysisFolder } from "../fullAnalysis/IAnalysisFolder";
import gDriveIcon from "../../../../assets/files/gdrive.svg";
import analysisIcon from "../../../../assets/files/puzzle-b-y.png";
import "./DesktopFileItem.css";
import { fixHTMLSpaces, formatFileName } from "../../../../utils/dateFormats";
import { getFolderIconByIndex } from "../../../../utils/folderIcons";

const providerIcons = {
    'g': gDriveIcon,
    'analysis': analysisIcon
}

interface IDesktopFileItemProps{
    item: IAnalysisFolder,
    isSelected: boolean,
    isUnderDrop: boolean,
    isUnderFileDrop?: boolean,
    isRenaming: boolean,
    onRename: (name: string)=>void,
    onClick?: ()=>void,
    onMouseDown?: ()=>void,
    onDoubleClick: ()=>void,
    onContextMenu: (e:React.MouseEvent)=>void
}

export const DesktopFileItem = ({item, isUnderDrop, isUnderFileDrop, isSelected, isRenaming, onRename, onClick, onMouseDown, onDoubleClick, onContextMenu}:IDesktopFileItemProps)=>{
    const [name, setName] = useState('');
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const noRenameByClick = true;
    const [fullName, setFullName] = useState(false);
    const [clickTimeout, setClickTimeout] = useState<NodeJS.Timeout | null>(null);

    useEffect(()=>{
        setName(item.name)
    }, [item.name]);

    useEffect(()=>{
        if (isRenaming && inputRef.current){
            inputRef.current.focus();
            // Select all text like Windows does when renaming
            inputRef.current.select();
        }
    }, [isRenaming, inputRef.current]);

    const handleClick = () => {
        if (clickTimeout) {
            // Double click detected
            clearTimeout(clickTimeout);
            setClickTimeout(null);
            onDoubleClick();
        } else {
            // Single click - wait to see if double click follows
            const timeout = setTimeout(() => {
                onClick?.();
                setClickTimeout(null);
            }, 500); // 500ms delay to detect double click (Windows standard)
            setClickTimeout(timeout);
        }
    };
    return <div className={`desktop_file ${isSelected ? 'desktop_file_selected' : ''} ${(isUnderDrop || isUnderFileDrop) ? 'desktop_file_underDrop' : ''}`} onClick={handleClick} onMouseDown={onMouseDown} onContextMenu={onContextMenu}>
        <div className="desktop_file_icon" style={{backgroundImage:`url(${getFolderIconByIndex(item.iconIndex || 0)})`}}>
            {item.type === 'file' && <div className="desktop_file__fileIndicator">📄</div>}
            {item.link && <div className={`desktop_file__linkIcon ${'desktop_file__linkIcon--'+item.linkProvider}`} style={{backgroundImage:`url(${providerIcons[item.linkProvider as keyof typeof  providerIcons] || ''})`}}>
            
            </div>}
        </div>
        {
            isRenaming ? <div className="desktop_file_renameInput_wrap">
                <div className="desktop_file_name desktop_file_name_sizer">
                    {fixHTMLSpaces(name)}
                </div>
                <textarea 
                    onMouseDown={(e)=>e.stopPropagation()}
                    ref={inputRef} className="desktop_file_renameInput" 
                    onClick={(e)=>{e.stopPropagation()}} 
                    value={name} 
                    onChange={e=>setName(e.target.value)} 
                    onBlur={()=>{onRename(name)}}
                    onKeyDown={(e)=>{
                        if (e.code == 'Enter'){
                            e.preventDefault(); // Prevent new line from being added
                            onRename(name);
                        }
                    }}
                />
            </div>
            :
            <div onMouseOver={()=>setFullName(true)} onMouseLeave={()=>setFullName(false)} className={`desktop_file_name ${noRenameByClick ? 'desktop_file_name_noRename':''}`}>
                {fullName ? item.name : formatFileName(item.name)}
            </div>
        }
        <div className="desktop_file_tint">
            <div className={isUnderFileDrop ? "desktop_file_plus" : "desktop_file_arrow"}></div>
        </div>
    </div>
}